// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"744e8392","254":"a957df87","618":"99a2a8a1","817":"cf7d1d0b"}[chunkId] + ".chunk.js";
};